<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Şirket Z Raporu</h1>
      <div class="SayfaBtn el-button-group">
        <el-button v-if="KasaEkstre" size="small" type="default" @click="Yazdir" :disabled="lo">Yazdır</el-button>
        <el-button size="small" type="default" @click="Getir" :disabled="lo">Rapor Oluştur</el-button>
      </div>
    </div>
    <div class="SayfaIcerik" v-loading="lo" >
      <div class="yazdirtable yazdirtablegoster">
        <h1>{{ Tarih }} TARİHLİ Z RAPORU</h1>
        <el-row>
          <el-col :span="24">
            <table class="table">
              <thead>
              <tr>
                <th colspan="7" class="table-text-center">KASA HAREKET</th>
              </tr>
              <tr>
                <th>No.</th>
                <th>Proje</th>
                <th>Cari</th>
                <th>Açıklama</th>
                <th class="text-right">Gelir</th>
                <th class="text-right">Gider</th>
                <th class="text-right">Bakiye</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="t in KasaEkstre">
                <td>{{ t.id }}</td>
                <td>{{ t.Proje }}</td>
                <td>{{ t.Unvan }}</td>
                <td>{{ t.Aciklama }}</td>
                <td class="text-right">{{ t.Gelir }}</td>
                <td class="text-right">{{ t.Gider }}</td>
                <td class="text-right">{{ t.Bakiye }}</td>
              </tr>
              </tbody>
              <tfoot v-if="AltToplam">
              <tr>
                <th colspan="4" class="text-right">Hareket Alt Toplam</th>
                <th class="text-right">{{ AltToplam.Gelir }}</th>
                <th class="text-right">{{ AltToplam.Gider }}</th>
                <th class="text-right">{{ AltToplam.Bakiye }}</th>
              </tr>
              <tr>
                <th colspan="4" class="text-right">Devir Kasa</th>
                <th class="text-right">{{ AltToplam.DevirGelir }}</th>
                <th class="text-right">{{ AltToplam.DevirGider }}</th>
                <th class="text-right">{{ AltToplam.DevirBakiye }}</th>
              </tr>
              <tr>
                <th colspan="4" class="text-right">Güncel Kasa</th>
                <th class="text-right">{{ AltToplam.ToplamGelir }}</th>
                <th class="text-right">{{ AltToplam.ToplamGider }}</th>
                <th class="text-right">{{ AltToplam.ToplamBakiye }}</th>
              </tr>
              </tfoot>
            </table>
          </el-col>
          <el-col :span="24" v-if="Projeler">
            <table class="table" style="margin-top: 20px;">
              <thead>
              <tr>
                <th colspan="6" class="table-text-center">GÜNCEL PROJE DURUMLARI</th>
              </tr>
              <tr>
                <th>Proje</th>
                <th class="text-right">Varlık</th>
                <th class="text-right">Demirbaş</th>
                <th class="text-right">Stok</th>
                <th class="text-right">Alacak</th>
                <th class="text-right">Borç</th>
                <th class="text-right">Kasa</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="Projeler" v-for="p in Projeler">
                <td>{{ p.Adi }}</td>
                <td class="text-right  ">{{ p.Hesap.VarlikTx }}</td>
                <td class="text-right  ">{{ p.Hesap.DemirbasTx }}</td>
                <td class="text-right ">{{ p.Hesap.StokTx }}</td>
                <td class="text-right ">{{ p.Hesap.AlacakTx }}</td>
                <td class="text-right ">{{ p.Hesap.BorcTx }}</td>
                <td class="text-right ">{{ p.Hesap.KasaTx }}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr v-if="AltToplam">
                <th></th>
                <th class="text-right">{{ AltToplam.VarlikTx }}</th>
                <th class="text-right">{{ AltToplam.DemirbasTx }}</th>
                <th class="text-right">{{ AltToplam.StokTx }}</th>
                <th class="text-right">{{ AltToplam.AlacakTx }}</th>
                <th class="text-right">{{ AltToplam.BorcTx }}</th>
                <th class="text-right">{{ AltToplam.KasaTx }}</th>
              </tr>
              </tfoot>
            </table>
          </el-col>
          <!--el-col :span="6" v-if="AltToplam">
            <table class="table" style="margin-top: 20px;">
              <thead>
              <tr>
                <th colspan="2" class="table-text-center">GÜNCEL KASA DURUMLARI</th>
              </tr>
              <tr>
                <th>Kasa Adı</th>
                <th class="text-right">Bakiye</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="k in Kasalar">
                <td>{{ k.Adi }}</td>
                <td class="text-right">{{ k.TutarTx }}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th></th>
                <th class="text-right">{{ AltToplam.KasaTx }}</th>
              </tr>
              </tfoot>
            </table>
          </el-col-->
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      KasaEkstre: null,
      Tarih: null,
      AltToplam: null,
      StokHareket: null,
      Projeler: null,
      lo: false,
      Form: []
    }
  },
  methods: {
    Yazdir() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
    Getir() {
      this.lo = true
      this.$store.dispatch("Post", {...this.Form, path: 'rapor/zraporu'})
          .then(response => {
            if (response.Durum === "OK") {
              this.lo = false
              this.KasaEkstre = response.Data
              this.Tarih = response.Tarih
              this.StokHareket = response.StokHareket
              this.AltToplam = response.AltToplam
              this.Projeler = response.Projeler
              this.Kasalar = response.Kasalar
            }
          })
    },
  },
  created() {
    this.$store.dispatch("title", "Z Raporu");
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/zRaporu.vue